import { CommentGuardIcon } from '@mm/icons/StarterIcons';
import quoteImg from 'assets/icons/quote.svg';
import React from 'react';
import { colors } from '../../../../beta/styles/colors';
import './IGCommentGuardMessage.pcss';

type Props = {
  displayText: string;
};

export const IGCommentGuardMessage = (props: Props) => {
  const { displayText } = props;

  return (
    <div className="ig-comment-guard-message__container">
      <div className="ig-comment-guard-message__title">
        <CommentGuardIcon
          className="ig-comment-guard-message__icon"
          color={colors.accentBlue}
        />
        User left a comment on your post
      </div>
      <div className="ig-comment-guard-message__body">
        <img className="ig-comment-guard-message__quote" src={quoteImg} />
        {displayText}
      </div>
    </div>
  );
};
